<template><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 0L15.6826 8.31739L24 12L15.6826 15.6826L12 24L8.31739 15.6826L0 12L8.31739 8.31739L12 0Z"
            fill="url(#paint0_linear_1772_9548)" />
        <defs>
            <linearGradient id="paint0_linear_1772_9548" x1="6.5" y1="-1.1238e-07" x2="24" y2="24"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#47D18C" />
                <stop offset="1" stop-color="#66A3FF" />
            </linearGradient>
        </defs>
    </svg>
</template>